"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgFilter = function SvgFilter(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    className: "filter_svg__border",
    d: "M9.5 11.395v1.59l-3 1.5v-3.09a4.5 4.5 0 0 0-.74-2.472L1.436 2.346a.5.5 0 0 1 .418-.775h12.292a.5.5 0 0 1 .418.775L10.24 8.923a4.5 4.5 0 0 0-.74 2.472Z",
    stroke: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    className: "filter_svg__filled",
    d: "m12.673 4.818-9.106.919 2.936 4.577.221 3.756 2.462-1.136.474-3.41 3.013-4.706Z",
    fill: "#4D4D4D"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgFilter);
var _default = exports["default"] = Memo;